interface SurveySidemenuStatusProps {
    statusToRender: boolean | undefined;
    isIncomplete: boolean | undefined;
    validationType?: string;
}

// Validation map 
//     "Fail": "0",
//     "Pass": "1",
//     "NoLongerAvailable": "2",
//     "NeverSold": "3"
// 

const SurveySidemenuStatus: React.FC<SurveySidemenuStatusProps> = ({statusToRender, isIncomplete, validationType}) => {
    const isUnavailable = validationType == "2" || validationType == "3"; 
  
    if (isUnavailable) {
        return (
            <>
                {statusToRender === true ? (
                    <span className="glyphicon glyphicon-remove-sign text-gray-400"></span>
                ) : (
                        <div className="Unavailable-status-placeholder" data-validation-type={validationType}></div>
                )}
            </>
        );
    }
    return (
        <>
            {statusToRender === true ? (
                <span className={`glyphicon glyphicon-ok-sign ${isIncomplete ? "pending" : ""}`}></span>
            ) : (
                <div className="status-placeholder"></div>
            )}
        </>
    );
}

export default SurveySidemenuStatus;